export default __webpack_public_path__ + "static/media/featured3.66d68644.jpg";